import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { withRouter } from "react-router-dom";
import ResizeDetector from "react-resize-detector";
import AppMain from "../../Layout/AppMain";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedSmallerSidebar: false,
    };
  }

  componentDidMount() {
    // console.log("Current URL Path:", this.props.location.pathname);
    // this.restrictManualUrlChange();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // console.log(this.props.location.pathname);
      // this.checkAndRedirect();
    }
  }

  checkAndRedirect = () => {
    const allowedRoutes = [
      // "/", 
      "/components", 
      "/forms", 
      "/charts", 
      "/tables", 
      "/elements", 
      "/widgets", 
      "/pages", 
      "/apps", 
      "/dashboards",
      "/properties",
      "/verification",
      // "/verification/propertyverification",
      "/users",
      "/advertisement",
      "/masters",
      "/landmarks",
      "/settings"
    ];

    const currentPath = this.props.location.pathname;
    
    if (!allowedRoutes.some(route => currentPath.startsWith(route))) {
      
      this.props.history.replace("/");
    }
  };

  restrictManualUrlChange = () => {
    const allowedRoutes = ["/", "/components", "/forms", "/charts"];

    window.addEventListener("popstate", () => {
      const currentPath = window.location.pathname;
      if (!allowedRoutes.includes(currentPath)) {
        this.props.history.replace("/");
      }
    });
  };

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
    } = this.props;

    const { pathname } = this.props.location;

    return (
      <ResizeDetector
        handleWidth
        render={({ width }) => (
          <Fragment>
            <div
              className={cx(
                "app-container app-theme-" + colorScheme,
                { "fixed-header": enableFixedHeader },
                { "fixed-sidebar": enableFixedSidebar || width < 1250 },
                { "fixed-footer": enableFixedFooter },
                { "closed-sidebar": enableClosedSidebar || width < 1250 },
                { "closed-sidebar-mobile": closedSmallerSidebar || width < 1250 },
                { "sidebar-mobile-open": enableMobileMenu },
                { "body-tabs-shadow-btn": enablePageTabsAlt }
              )}
            >
              {(pathname === "/" || pathname === "/forgotpassword") && <AppMain />}
              {pathname !== "/" && pathname !== "/forgotpassword" && (
                <>
                  <AppHeader />
                  <div className="app-main">
                    <AppSidebar />
                    <div className="app-main__outer">
                      <div className="app-main__inner">
                        <AppMain />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Fragment>
        )}
      />
    );
  }
}

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

export default withRouter(connect(mapStateToProp)(Main));
